import React, { useState, useReducer, createContext } from "react";
import { useRouteMatch } from "react-router-dom";

import {
  Box,
  Container,
  Tab
} from "@mui/material";
//page imports
import PaymentMethod from "./PaymentMethod";
import PaymentHost from "./PaymentHost";
import PaymentBrand from "./PaymentBrand";
import PaymentMethodHistory from "./PaymentMethodHistory";
import PaymentBrandHistory from "./PaymentBrandHistory";
import PaymentHostHistory from "./PaymentHostHistory";
import PaymentMethodPending from "../Admin-PaymentMethod/PaymentMethodPending";
import PaymentHostPending from "./PaymentHostPending";
import PaymentBrandPending from "../Admin-PaymentBrand/PaymentBrandPending";

//dialog imports
import CreateMethodDialog from "./Dialogs/CreateMethodDialog";
import CreateBrandDialog from "./Dialogs/CreateBrandDialog";
import CreateHostDialog from "./Dialogs/CreateHostDialog";
import paymentHostReducer from "../../reducer/admin/paymentHost";
import { prefixV3 } from "../../utils/constants";
import HeaderHelpPage from "../HeaderHelpPage";
import TabsMenu from "../TabsMenu";
import { TabPanel } from "@mui/lab";

const selected = {
  [prefixV3 + "/operations/payment-host"]: "Payment Host",
  [prefixV3 + "/operations/payment-brand"]: "Payment Brand",
  [prefixV3 + "/operations/payment-method"]: "Payment Method",
};

export const PaymentHostContext = createContext();

function PaymentHostSwitchView({ userRole }) {
  const match = useRouteMatch();
  const [state, dispatch] = useReducer(paymentHostReducer, {});
  const selectedDefault = selected[match.path];
  const [selectedView, setSelectedView] = useState("All");

  const handleChange = (event, value) => {
    setSelectedView(value);
  };

  const renderCreateDialog = () => {
    if (!userRole.includes("Add") || selectedView !== "All") return null;

    switch (selectedDefault) {
      case "Payment Method":
        return <Box><CreateMethodDialog /></Box>;
      case "Payment Brand":
        return <Box><CreateBrandDialog /></Box>;
      case "Payment Host":
        return <Box><CreateHostDialog /></Box>;
      default:
        return null;
    }
  };

  return (
    <PaymentHostContext.Provider value={{ state, dispatch }}>
      <Container>
        <HeaderHelpPage
          title={selectedDefault}
          description={`This page manage ${selectedDefault} available on our system`}
        />
        <TabsMenu value={selectedView} onChange={handleChange}>
          <Tab label="All" value="All" />
          <Tab label="Pending" value="Pending" />
          <Tab label="History" value="History" />

          {renderCreateDialog()}

          <TabPanel value="All">
            {selectedDefault === "Payment Method" && (
              <PaymentMethod userRole={userRole} />
            )}
            {selectedDefault === "Payment Brand" && (
              <PaymentBrand userRole={userRole} />
            )}
            {selectedDefault === "Payment Host" && (
              <PaymentHost userRole={userRole} />
            )}
          </TabPanel>
          <TabPanel value="Pending">
            {selectedDefault === "Payment Method" && (
              <PaymentMethodPending userRole={userRole} />
            )}
            {selectedDefault === "Payment Brand" && (
              <PaymentBrandPending userRole={userRole} />
            )}
            {selectedDefault === "Payment Host" && (
              <PaymentHostPending userRole={userRole} />
            )}
          </TabPanel>
          <TabPanel value="History">
            {selectedDefault === "Payment Method" && <PaymentMethodHistory />}
            {selectedDefault === "Payment Brand" && <PaymentBrandHistory />}
            {selectedDefault === "Payment Host" && <PaymentHostHistory />}
          </TabPanel>
        </TabsMenu>
      </Container>
    </PaymentHostContext.Provider>
  );
}

export default PaymentHostSwitchView;
